module.exports = __webpack_public_path__ + "img/page_plan.dfde2e65.svg";